module.exports = __webpack_public_path__ + "img/ic-lineplot-triangle.0f6da5e8.svg";